export const SOCIALS = [
  {
    href: "https://github.com/mondevyat",
    img: "https://i.ibb.co/MZ0mM56/git.png",
    alt: "git",
    underline: "G",
    rest: "ithub",
    hotkey: "g",
  },
  {
    href: "https://t.me/mondevyat",
    img: "https://i.ibb.co/Pxm5D5T/telega3.png",
    alt: "tele",
    prefix: "Telegra",
    underline: "m",
    rest: "",
    hotkey: "m",
  },
  {
    href: "https://www.instagram.com/mondevyat/",
    img: "https://i.ibb.co/Jrkbj95/insta2.png",
    alt: "inst",
    underline: "In",
    rest: "stagram",
    hotkey: "i",
  },
  {
    href: "https://www.facebook.com/artem.monchenko/",
    img: "https://i.ibb.co/SxPxwGh/facebook.png",
    alt: "vk",
    underline: "F",
    rest: "acebook",
    hotkey: "f",
  },
  {
    href: "mailto:artemii.origin@yandex.ru?subject=Frontend developer needed!",
    img: "https://i.ibb.co/Wyk8zvJ/letter.png",
    alt: "xz",
    underline: "E",
    rest: "mail",
    hotkey: "e",
  },
];

export const SHUT_DOWN = {
  href: " ",
  img: "https://i.ibb.co/pRSLfNf/turn-off-computer-d.png",
  alt: "shut",
  hotkey: "u",
};
